import { canvasDimension } from '@/constants/canvas';
import { useEvent } from './useEvent';
import { useEffect } from 'react';

const useCanvasResize = () => {
  const onResize = (delay = 0) => {
    setTimeout(() => {
      const canvas: any = document.getElementById('game_canvas');
      const canvasHeight = canvasDimension.HEIGHT;
      const canvasWidth = canvasDimension.WIDTH;
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;

      const heightScaleFactor = viewportHeight / canvasHeight;
      const widthScaleFactor = viewportWidth / canvasWidth;
      const scaleFactor = Math.min(heightScaleFactor, widthScaleFactor);
      if (canvas) {
        canvas.style.transform = `scale(${scaleFactor})`;
      }
    }, delay);
  };
  useEvent('resize', () => {
    onResize(500);
  });
  useEffect(() => {
    onResize(0);
  }, []);
};

export { useCanvasResize };
